const DEFAULT_SITE_URL = 'https://diamond.salon'

function normalizeSiteUrl(value: string | undefined) {
  const candidate = value?.trim() || DEFAULT_SITE_URL

  try {
    const url = new URL(candidate)
    if (!['http:', 'https:'].includes(url.protocol)) return DEFAULT_SITE_URL
    return url.href.replace(/\/$/, '')
  } catch {
    return DEFAULT_SITE_URL
  }
}

export const SITE_NAME = 'Diamond Salon & Spa'
export const SITE_URL = normalizeSiteUrl(import.meta.env.VITE_SITE_URL)
export const DEFAULT_SOCIAL_IMAGE = '/og.de6c6ebb.jpg'
export const SITE_DESCRIPTION = 'Personalized hair and spa services in San Juan Capistrano, California.'

export function absoluteSiteUrl(path = '/') {
  const normalizedPath = path === '/' ? '/' : `/${path.replace(/^\/+|\/+$/g, '')}`
  return new URL(normalizedPath, `${SITE_URL}/`).href
}
